// Mirrors the backend's forward-only enforcement (server.py move_stage /
// update_deal). Keep these two ordered lists in lockstep with the server.
import { STAGES } from "@/lib/format";

export const STAGE_KEYS = STAGES.map((s) => s.key);
export const TERMINAL_STAGES = new Set(["won", "lost", "dropped"]);

export function isTerminalStage(stage) {
  return TERMINAL_STAGES.has(stage);
}

/**
 * A move is backward when the target stage's index is strictly lower than the
 * current stage's index AND the target isn't a terminal stage. Terminal
 * stages (won/lost/dropped) are reachable from anywhere.
 */
export function isBackwardMove(fromStage, toStage) {
  if (!fromStage || !toStage || fromStage === toStage) return false;
  if (isTerminalStage(toStage)) return false;
  const o = STAGE_KEYS.indexOf(fromStage);
  const n = STAGE_KEYS.indexOf(toStage);
  if (o === -1 || n === -1) return false;
  return n < o;
}
